module.exports = __webpack_public_path__ + "static/img/DINProLight.c7a52bbd.svg";